import React from 'react';
import ServerError from '../../pages/auth/ServerError';

/**
 * ErrorBoundary — catches unhandled render / lifecycle errors.
 *
 * Usage:  <ErrorBoundary><App /></ErrorBoundary>
 *
 * On error it renders the ServerError (500) page with a "Try Again"
 * action that resets the boundary and re-mounts the tree.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log to console (and optionally to Sentry / remote logger)
        console.error('[ErrorBoundary] Uncaught error:', error, errorInfo);
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return <ServerError onRetry={this.handleRetry} />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
